import { DecimalPipe, DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TableTransactionsReservaService } from './table-transactions-reserva.service';
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import {ToastrService} from "ngx-toastr";
import { saveAs } from 'file-saver';
import { PdfService } from 'src/app/shared/services/pdf.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { TranslateService, LangChangeEvent  } from '@ngx-translate/core';
import { ReservaGgrService } from '../reserva-ggr/reserva-ggr/reserva-ggr.service';


@Component({
    selector: 'app-table-transactions-reserva',
    templateUrl: './table-transactions-reserva.component.html',
    styleUrls: ['./table-transactions-reserva.component.scss'],
    providers: [TableTransactionsReservaService, DecimalPipe, DatePipe]
})
    export class TableTransactionsReservaComponent {

    public dataInitial!: NgbDateStruct;
    public dataFinal!: NgbDateStruct;
    public transactionType: string = '';
    public selectedStatus: string = '';
    public selectedOrigin: string = '';
    public selectedApplciation: string = '';
    public personName: string = '';
    public searchType: string = '';
    public page: number = 1;
    public pageSize: number = 20;
    public total: number = 0;
    public receiptTemplate: string = '';
    public bankProvider: Array<any> = [];
    public nameColumn: string = '';
    public account: any;
    public transactions: Array<any> = [];
    public accountIdGeneric: string = '';
    public isLoading: boolean = true;
    langChangeSub!: Subscription;

    constructor(private reservaGgrService: ReservaGgrService,
                private tableTransactionsReservaService: TableTransactionsReservaService,
                private toastr: ToastrService,
                private pdfService: PdfService,
                private translate: TranslateService)
    {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate());

        this.dataInitial = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() }
        this.dataFinal = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() }
        this.selectedStatus = 'REALIZADO';
        this.getReserveAccounts();
    }
    

    async ngOnInit(): Promise<void> {
      this.setTranslatedNameColumn();

      this.langChangeSub = this.translate.onLangChange.subscribe(() => {
        this.setTranslatedNameColumn();
     })
    }

    async getReserveAccounts(): Promise<void> {
      try{
        const account = await this.reservaGgrService.getAccount();
        this.account = account
        this.accountIdGeneric = account.listsAccountTef?.[0] ?? '';
        this.getTransactions();
      }
      catch {
        this.toastr.error('Não foi possível carregar a conta');
      }
    }
    
    setTranslatedNameColumn(): void {
      this.translate.get(['common.license', 'common.split']).subscribe(translations => {
        if (this.account?.nameColumn?.includes('LICENCIADO')) {
          this.nameColumn = translations['common.license'];
        } else {
          this.nameColumn = translations['common.split'];
        }
      });
    }

    isValidPixDate(transactionDate: string): boolean {
      const targetDate = new Date('2025-02-05T00:00:00Z');
      const transactionDateObj = new Date(transactionDate);

      return transactionDateObj.getTime() >= targetDate.getTime();
    }

    isValidTefDate(transactionDate: string): boolean {
      const targetDate = new Date('2025-05-02T00:00:00Z');
      const transactionDateObj = new Date(transactionDate);

      return transactionDateObj.getTime() >= targetDate.getTime();
    }

    public getTransactions() {
        this.getBankProvider();
        this.getAccount();
        let dateInitialFormat = `${this.dataInitial.year}-${this.dataInitial.month}-${this.dataInitial.day}`;
        let dateFinalFormat = `${this.dataFinal.year}-${this.dataFinal.month}-${this.dataFinal.day}`;
        this.reservaGgrService.getTransactionsExtrato(dateInitialFormat, dateFinalFormat, this.transactionType, this.selectedStatus, this.selectedOrigin, this.selectedApplciation, this.personName, this.page, this.pageSize, this.searchType, this.accountIdGeneric).subscribe(
            value => {
                this.transactions = value.transactions;
                this.total = value.total;
                this.isLoading = false;
            }, () => {
              this.isLoading = false;
            }
        )
    }

    public getBankProvider() {
      this.tableTransactionsReservaService.getBankProvider().subscribe(
          value => {
              this.bankProvider = value.data;
          }
      )
    }

    public getAccount() {
      this.tableTransactionsReservaService.getAccount().then(
        value => {
          this.account = value;
          if (this.account?.nameColumn) {
            if (this.account.nameColumn.includes('LICENCIADO')) {
              this.nameColumn = this.translate.instant('common.license');
            } else {
              this.nameColumn = this.translate.instant('common.split');
            }
          }
        }
      ).catch(error => {
        console.error('Error fetching account:', error);
      });
    }

    pageChange() {
        this.getTransactions();
    }

    async downloadReceipt(transaction: any) {
      this.toastr.success('Seu comprovante está sendo gerado','Sucesso',{
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });

      const response = await firstValueFrom(this.pdfService.reportWithdraw(transaction));

      const byteCharacters = atob(response);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);


      const blob = new Blob([byteArray], { type: 'application/pdf' });
      saveAs(blob, 'comprovante.pdf');
    }
}



